module.exports = __webpack_public_path__ + "media/images/client-16-ae515b05ebb699db430073ab63c943ee.png";